var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// BluePrint JS
import { Button as BPButton } from '@blueprintjs/core';
import classNames from 'classnames';
// components
import { Spinner } from '../';
// constants
import { prefix } from '../../constants';
export const Button = (_a) => {
    var { type, size = 'standard', style, iconOnly = false, leftIcon, rightIcon, children, className, loading } = _a, props = __rest(_a, ["type", "size", "style", "iconOnly", "leftIcon", "rightIcon", "children", "className", "loading"]);
    // translate 'style' prop to 'minimal' and 'intent' props (consumed by the BlueprintJS) to simplify the styling props for our common button
    // more conditions will be added later
    let minimal = false;
    let intent = 'none';
    // Convert s/m/l size to design/style names (with standard as default just in case)
    const convertedSize = {
        s: 'compact',
        m: 'standard',
        l: 'large',
    }[size] || 'standard';
    switch (style) {
        case 'subtle':
            minimal = true;
            break;
        case 'standard':
            minimal = false;
            break;
        case 'primary':
            minimal = false;
            intent = 'primary';
            break;
        case 'success':
            minimal = false;
            intent = 'success';
            break;
        default:
    }
    const buttonContent = !iconOnly &&
        (loading ? (React.createElement(React.Fragment, null,
            React.createElement(Spinner, { loading: true, size: "s", centered: true }),
            React.createElement("span", { className: "button_text" }, children))) : (children));
    return (React.createElement(BPButton, Object.assign({ className: classNames(className, `${prefix}-button`, {
            [convertedSize]: style !== 'boilerplate',
            'button-boilerplate': style === 'boilerplate',
            icon: leftIcon || rightIcon,
            'icon-only': iconOnly,
            'icon-left': leftIcon && !rightIcon,
            'icon-right': rightIcon && !leftIcon,
            'icon-both-sides': leftIcon && rightIcon,
        }, loading && 'is-loading-button'), type: type }, props, { minimal: minimal, intent: intent, icon: leftIcon, rightIcon: rightIcon, children: buttonContent })));
};
//# sourceMappingURL=Button.js.map